import { IEvent, ILabel, ISpineData, Meter, SpineBase } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-leopard";


export class MagicPotionFeatureViewFG extends BaseViewBehavior {

    //Method overrided to remove baseView method functionality
    protected resize(e?: IEvent): void {
        if (!ingenuity.deviceEnv.isDesktop) {
            if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
                this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
                this.updateOrientation();
            }
        }

    }

    // Method getSpineJsonAndClone get and clone spine
    public getSpineJsonAndClone(potIdentifier: string): SpineBase {
        let stackSpineJsonObj: ISpineData = this.json[potIdentifier];
        stackSpineJsonObj.type = "spine";
        let stackSpineCloneAnim: SpineBase = this.createSpine(stackSpineJsonObj);
        stackSpineCloneAnim.visible = false;
        return stackSpineCloneAnim;
    }

    //Method getCloneWinValueMeter clone meter
    public getCloneWinValueMeter(): Meter {
        let cloneWinValueMeterObj: ILabel = this.json["jackpot_prize"];
        cloneWinValueMeterObj.type = "meter";
        let cloneWinValueMeter: Meter = this.createMeter(cloneWinValueMeterObj);
        cloneWinValueMeter.visible = false;
        return cloneWinValueMeter;
    }

}